import { Type } from '@avro/types/lib'

/**
 * Encode data to base64 string using `@avro`
 */
export const encodeAvro = <T>(data: T, encoder: Type<T>) => {
  const binaryEncode = encoder.binaryEncode(data)
  return binaryEncode.toString('base64')
}

/**
 * Decode data from base64 string using `@avro`
 */
export const decodeAvro = <T>(encoded: string | Buffer, decoder: Type<T>) => {
  if (typeof encoded === 'string') {
    const binaryEncode = Buffer.from(encoded, 'base64')
    return decoder.binaryDecode(binaryEncode)
  }
  return decoder.binaryDecode(encoded)
}
